<template>
  <div class="result w-full bg-white">
    <div id="info-card" class="bg-white px-4 py-6 mb-2">
      <h1 class="font-semibold text-2xl mb-5">
        Skirining Lansia Sederhana (SKILAS)
      </h1>

      <!-- LIST SKILAS -->
      <p class="text-sm font-semibold my-2">Penurunan Kognitif</p>
      <ol class="text-base list-decimal ms-6">
        <li>Minta lansia untuk mengingat 3 kata.(contoh: bunga, pintu, nasi)</li>
        <li>Tanyakan orientasi waktu dan tempat pada lansia.
          <ol style="list-style-type: lower-alpha" class="ms-7">
            <li>Tanggal berapa sekarang?</li>
            <li>Dimana lokasi Anda saat ini?</li>
          </ol>
        </li>
        <li>Minta lansia untuk mengingat 3 kata sebelumnya.</li>
      </ol>
      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Salah pada satu pertanyaan</p>
          <Checked v-if="skilasVal?.cognitiveDecline?.includes('ONE_WRONG_ANSWER')" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Tidak dapat mengulangi kata yang diberikan.</p>
          <Checked v-if="skilasVal?.cognitiveDecline?.includes('UNABLE_TO_REPEAT')" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-sm font-semibold my-2">Keterbatasan Mobilisasi</p>
      <p class="text-base">
        Tes berdiri dari kursi: berdiri dari kursi sebanyak lima kali tanpa menggunakan tangan  <br/>
        Apakah orang tersebut dapat berdiri dari kursi sebanyak 5 kali dalam 14 detik?
      </p>

      <div class="flex flex-row justify-between">
        <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
          <div class="title flex flex-row justify-between">
            <p class="text-base text-[#979797] w-full me-3">Iya</p>
            <Checked v-if="skilasVal?.limitedMobility" class="w-5 h-5"/>
            <Unchecked v-else class="w-5 h-5"/>
          </div>
        </div>

        <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
          <div class="title flex flex-row justify-between">
            <p class="text-base text-[#979797] w-full me-3">Tidak</p>
            <Checked v-if="!skilasVal?.limitedMobility" class="w-5 h-5"/>
            <Unchecked v-else class="w-5 h-5"/>
          </div>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-sm font-semibold my-2">Malnutrisi</p>
      <p class="text-base">
        Apakah berat badan Anda berkurang &gt; 3 kg dalam tiga bulan terakhir atau pakaian menjadi lebih longar?
      </p>

      <div class="flex flex-row justify-between">
        <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
          <div class="title flex flex-row justify-between">
            <p class="text-base text-[#979797] w-full me-3">Iya</p>
            <Checked v-if="skilasVal?.weightLoss" class="w-5 h-5"/>
            <Unchecked v-else class="w-5 h-5"/>
          </div>
        </div>

        <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
          <div class="title flex flex-row justify-between">
            <p class="text-base text-[#979797] w-full me-3">Tidak</p>
            <Checked v-if="!skilasVal?.weightLoss" class="w-5 h-5"/>
            <Unchecked v-else class="w-5 h-5"/>
          </div>
        </div>
      </div>

      <p class="text-base">
        Apakah Anda hilang nafsu makan atau mengalami kesulitan makan (misal batuk atau tersedak saat makan, menggunakan selang makan/sonde?)
      </p>

      <div class="flex flex-row justify-between">
        <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
          <div class="title flex flex-row justify-between">
            <p class="text-base text-[#979797] w-full me-3">Iya</p>
            <Checked v-if="skilasVal?.lossOfAppetite" class="w-5 h-5"/>
            <Unchecked v-else class="w-5 h-5"/>
          </div>
        </div>

        <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
          <div class="title flex flex-row justify-between">
            <p class="text-base text-[#979797] w-full me-3">Tidak</p>
            <Checked v-if="!skilasVal?.lossOfAppetite" class="w-5 h-5"/>
            <Unchecked v-else class="w-5 h-5"/>
          </div>
        </div>
      </div>

      <p class="text-base">
        Apakah ukuran lingkar lengan atas (LiLA) &lt; 21 cm?
      </p>

      <div class="flex flex-row justify-between">
        <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
          <div class="title flex flex-row justify-between">
            <p class="text-base text-[#979797] w-full me-3">Iya</p>
            <Checked v-if="skilasVal?.upperArmCircumference" class="w-5 h-5"/>
            <Unchecked v-else class="w-5 h-5"/>
          </div>
        </div>

        <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
          <div class="title flex flex-row justify-between">
            <p class="text-base text-[#979797] w-full me-3">Tidak</p>
            <Checked v-if="!skilasVal?.upperArmCircumference" class="w-5 h-5"/>
            <Unchecked v-else class="w-5 h-5"/>
          </div>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-sm font-semibold my-2">Gangguan Penglihatan</p>
      <p class="text-base">
        Apakah Anda mengalami masalah pada mata: kesulitan melihat jauh, membaca, penyakit mata, atau sedang dalam pengobatan medis (diabetes, tekanan darah tinggi)?
      </p>

      <div class="flex flex-row justify-between">
        <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
          <div class="title flex flex-row justify-between">
            <p class="text-base text-[#979797] w-full me-3">Iya</p>
            <Checked v-if="skilasVal?.eyeProblems" class="w-5 h-5"/>
            <Unchecked v-else class="w-5 h-5"/>
          </div>
        </div>

        <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
          <div class="title flex flex-row justify-between">
            <p class="text-base text-[#979797] w-full me-3">Tidak</p>
            <Checked v-if="!skilasVal?.eyeProblems" class="w-5 h-5"/>
            <Unchecked v-else class="w-5 h-5"/>
          </div>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <template v-if="!skilasVal?.eyeProblems">
        <p class="text-sm font-semibold my-2">Tes Melihat</p>
        <p class="text-base">
          Lakukan “TES MELIHAT”. Apakah jawaban hitung jari benar dalam 3 kali berturut turut?
        </p>

        <div class="flex flex-row justify-between">
          <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
            <div class="title flex flex-row justify-between">
              <p class="text-base text-[#979797] w-full me-3">Iya</p>
              <Checked v-if="skilasVal?.visionTestSuccess" class="w-5 h-5"/>
              <Unchecked v-else class="w-5 h-5"/>
            </div>
          </div>

          <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
            <div class="title flex flex-row justify-between">
              <p class="text-base text-[#979797] w-full me-3">Tidak</p>
              <Checked v-if="!skilasVal?.visionTestSuccess" class="w-5 h-5"/>
              <Unchecked v-else class="w-5 h-5"/>
            </div>
          </div>
        </div>

        <!-- HR -->
        <hr class="my-4 bg-[#979797] h-[2px]">
      </template>

      <p class="text-sm font-semibold my-2">Gangguan Pendengaran</p>
      <p class="text-base">
        Lakukan “TES BISIK”. Apakah lansia dapat mendengar saat dilakukan “TES BISIK”?
      </p>

      <div class="flex flex-row justify-between">
        <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
          <div class="title flex flex-row justify-between">
            <p class="text-base text-[#979797] w-full me-3">Iya</p>
            <Checked v-if="skilasVal?.hearingDisorders" class="w-5 h-5"/>
            <Unchecked v-else class="w-5 h-5"/>
          </div>
        </div>

        <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2 w-[49%]">
          <div class="title flex flex-row justify-between">
            <p class="text-base text-[#979797] w-full me-3">Tidak</p>
            <Checked v-if="!skilasVal?.hearingDisorders" class="w-5 h-5"/>
            <Unchecked v-else class="w-5 h-5"/>
          </div>
        </div>
      </div>

      <!-- HR -->
      <hr class="my-4 bg-[#979797] h-[2px]">

      <p class="text-sm font-semibold my-2">Gejala Depresi</p>
      <p class="text-base">
        Selama dua minggu terakhir, apakah Anda merasa terganggu oleh:
      </p>

      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Perasaan sedih, tertekan, atau putus asa</p>
          <Checked v-if="skilasVal?.emotionalDisturbances?.includes('SADNESS')" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

      <div class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
        <div class="title flex flex-row justify-between">
          <p class="text-base text-[#979797] w-full me-3">Sedikit minat atau kesenagan dalam melakukan sesuatu</p>
          <Checked v-if="skilasVal?.emotionalDisturbances?.includes('LOW_INTEREST')" class="w-5 h-5"/>
          <Unchecked v-else class="w-5 h-5"/>
        </div>
      </div>

    </div>

    <Loading v-show="loading" class="top-0 left-0 bg-[rgba(0,0,0,0.25)]"/>
  </div>
</template>

<script setup>
import {
  computed,
} from 'vue';

import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import Loading from '@/components/LoadingOverlay.vue';
import Checked from '@/components/icons/Checked.vue';
import Unchecked from '@/components/icons/Unchecked.vue';

// import sanitizeHtml from 'sanitize-html';
const store = useStore();
const route = useRoute();

// const sanitizeOptions = ref({
//   allowedTags: ['ol', 'li', 'br', 'p', 'b'],
// });

const screeningResult = computed(() => {
  let result = store.state.screening.screeningData[store.state.screening.screeningIndex];
  if (route?.query?.page) {
    result = store.state.screening.screeningData[route?.query?.page - 1];
    store.dispatch('screening/setScreeningIndex', route?.query?.page - 1);
  }
  return result;
});

const skilasVal = computed(() => screeningResult.value?.skilas || {});

</script>

<script>
export default {
  name: 'SkilasDetailView',
};
</script>

<style lang="scss" scoped>

</style>
